var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{directives:[{name:"waypoint",rawName:"v-waypoint",value:({
    active: true,
    callback: _vm.onIntersection,
    options: _vm.intersectionOptions
  }),expression:"{\n    active: true,\n    callback: onIntersection,\n    options: intersectionOptions\n  }"}],ref:"stickyBlock",staticClass:"sticky-block",style:({ height: _vm.contentHeight + 'px' })},[_c('div',{ref:"contentBox",staticClass:"sticky-block__content",class:{ 'sticky-block__content--sticky': _vm.isSticky },style:({ backgroundColor: _vm.backgroundColor })},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }